import React, { Component } from 'react';
import {Button,InputGroup,Input,InputGroupAddon,Modal,ModalBody} from 'reactstrap';
import WarningMessage from '../../Message/WarningMessage/WarningMessage'
import { connect } from 'react-redux';
import * as url from '../../../utils/url';
import axios from '../../../axios';
import Loading from '../../../hoc/Loading/Loading';
import { getFlatDataFromTree } from 'react-sortable-tree';

import OfficeItems from './OfficeItems'


class OfficeNameChange extends Component {

  constructor(props) {
    super(props);
    this.state = {
        tree:null,
        oPath:null,
        newOfficesFound:this.props.newOfficesFound,
        savedChanges:[]
    }
  }

  changeNewOffice = (value, action, origName) =>{
    console.log("remove OFFICE NOW")
    let {newOfficesFound,savedChanges}=this.state
    // console.log(value)
    // if
    if(action==="add"){
      let result= newOfficesFound.map(e=> {
        let val;
        if(e.label===value.label){
          val= {...e, selected:true}
        }else {
          val= e
        }
        return val
      })

      savedChanges.push({oldName:origName, newName: value.label})
      this.setState(prevState=>({
        newOfficesFound:result,
        savedChanges
      }))
    } else {
      let result = newOfficesFound.map(e=> {
        if(e.label === value.label){
          return {...e, selected:false}
        }else {
          return e
        }
      })

      let s = savedChanges.filter(e=> e.oldName !== origName)

      this.setState(prevState=>({
        newOfficesFound:result,
        savedChanges: s
      }))
    }
  
  } 




  render() { 

    const {organizationId} = this.props.user.profile;
    const {staticHierarchy} = organizationId;
    const flat = getFlatDataFromTree({treeData : staticHierarchy,getNodeKey: ({ node }) => 
      node.id,ignoreCollapsed: false});
    const allOfficePaths = flat.map((p) => {
      const o = {};
      o.path = p.path.join('#');
      o.name = p.node.title;
      return o;
    });

    const {newOffices }=this.props
    const {newOfficesFound,savedChanges}=this.state
   
    return ( 
      <div className="officeHierachy">
        {/* <div onClick={this.saveNameChanges}> Save Changes </div> */}
        {/* Change office! */}
        <div className="newOffices">
        <span className="ooPink newOfficeTxt">
        New Offices
        </span>
        
        {newOfficesFound.map( (e,idx) =>{
            return (
                <div key={idx} className={e.selected?"officeItems ooBorder ooPink newOfficeSelected":"officeItems ooBorder ooPink"}>
                  {e.value}
                </div>
            )
        })}
        </div>


        <div className="originalOffices">
        <span className="ooBlue newOfficeTxt">
        Current Offices (click on the office names below and select the new office name)
        </span>
        
        {allOfficePaths.map( (e,idx) =>{
            return (
                <OfficeItems changeNewOffice={this.changeNewOffice} item={e} key={idx} newOffices={newOffices} newOfficesFound={newOfficesFound}/>
            )
        })}
        </div>
       


      </div>
    );
  }
}
 

const mapStateToProps = (state) => {
    return {
      user : state.user,

    }
  }
   
export default connect(mapStateToProps)(Loading(OfficeNameChange,axios));
  
